<script>
import Layout from '@layouts/main';
import AllowanceForm from '@views/allowances/form';

export default {
  name: 'AllowanceCreate',
  components: {
    Layout,
    AllowanceForm,
  },
  page() {
    return {
      title: this.$t('titles.create_allowance'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.allowances'),
          to: { name: 'allowances.index' },
        },
        {
          text: this.$t('titles.create_allowance'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'allowances.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_allowance')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <AllowanceForm @submitted="create" />
    </b-card>
  </Layout>
</template>
